import base from 'components/base'
import $ from 'jquery'

class login extends base
{
  elements = {
    container: null,
    form: null,
    logOutButton: null,
    openButton: null,
    closeButton: null
  }

  constructor()
  {
    super()

    $(document).ready(() =>
    {
      this.elements.container = $('#login').get(0)
      this.elements.form = $(this.elements.container).children('form').get(0)
      this.elements.logOutButton = $(this.elements.container).children('.log-out').get(0)
      this.elements.openButton = $(this.elements.container).children('.open').get(0)
      this.elements.closeButton = $(this.elements.container).children('.close').get(0)

      this.bindEvents()
    })
  }

  bindEvents()
  {
    $(this.elements.form).on('submit.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.logIn()
    })

    $(this.elements.logOutButton).on('click.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.logOut()
    })

    $(this.elements.openButton).on('click.'+ module.id, (event) =>
    {
      this.open(this.elements.container)
    })

    $(this.elements.closeButton).on('click.'+ module.id, (event) =>
    {
      this.close(this.elements.container)
    })
  }

  logIn()
  {
    let method = $(this.elements.form).attr('method')
    let url = $(this.elements.form).attr('action')
    let data = $(this.elements.form).serialize()

    this.runQuery({
      element: this.elements.container,
      type: method,
      url: url,
      input: data,
      events: {
        onSuccess: [(query) =>
        {
          if(typeof gtag === 'function')
          {
            this.processing = true
            $(this.elements.container).toggleClass('processing', true)

            gtag('event', 'login', {
              method: 'internal',
              event_callback: () =>
              {
                this.processing = false
                $(this.elements.container).toggleClass('processing', false)
                window.location.reload()
              }
            })
          }
          else
            window.location.reload()
        }]
      }
    })
  }

  logOut()
  {
    this.runQuery({
      element: this.elements.container,
      url: $(this.elements.logOutButton).attr('href'),
      events: {
        onSuccess: [(query) =>
        {
          if(query.response && query.response.redirect)
            window.location = query.response.redirect
        }]
      }
    })
  }
}

let instance = new login()

export default instance



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/login.js